const { axios_instance } = require("../api/axios_instance");
const { HighlightColValMapping } = require("./constant");
const { decryptRequest, encryptRequest } = require("./encryptdecryptrequest");

export const getHighlightedColVal = (dts_user) => {
  return HighlightColValMapping[dts_user]
    ? HighlightColValMapping[dts_user]
    : 0;
};

export const getPayMax = (caseDetails) => {
  return caseDetails.dts_pay_count ? caseDetails.dts_pay_count : 1;
};

export const getLastBalance = (caseDetails) => {
  return caseDetails.dts_bal_amt ? caseDetails.dts_bal_amt : 0;
};

export const verifyCheckBoxes = (caseDetails, dts_user) => {
  let res = false,
    check = false;
  if (
    (caseDetails.hasOwnProperty("save_as_draft") &&
      caseDetails.save_as_draft === 1) ||
    !caseDetails.hasOwnProperty("save_as_draft")
  ) {
    check = true;
  }
  if (
    dts_user === "MAKER" &&
    check &&
    [1, 2, 3, 4, 12, 14].includes(+caseDetails.sub_stage)
  ) {
    res = true;
  }
  return res;
};

export const checkHoldCase = async (lead_id, maker_id, sub_stage) => {
  try {
    const reqData = encryptRequest({
      lead_id,
      maker_id,
      sub_stage,
    });
    const result = await axios_instance({
      url: "/dts/getCaseHoldStatus",
      method: "POST",
      data: { reqData },
    });

    const decryptedData = decryptRequest(result.data.resData);
    return decryptedData.holdStatus && parseInt(decryptedData.holdStatus) !== 1;
  } catch (error) {
    return true;
  }
  // const
  // if (holdStatus && parseInt(holdStatus) !== 1) {
  //   return true;
  // }
  // return false;
};

export const holdCaseMessage = () =>
  "You can not make any changes until case is on hold.";

export const rtoParticularsValidate = (
  state,
  setState,
  visibilityObj,
  requiredSubStepFields
) => {
  const formFields = [
    { key: "HPT", subStepKey: "hpt_applicable" },
    { key: "HPA", subStepKey: "hpa_applicable" },
    {
      key: "nocAmountTranche",
      subStepKey: "noc_required_for_tranche",
    },
    {
      key: "NOCRequired",
      subStepKey: "noc_required",
    },
    {
      key: "isNameTransfer",
      subStepKey: "rc_transfer",
    },
    {
      key: "isInterRTOTransfer",
      subStepKey: "inter_rto_transfer",
    },
  ];

  const fieldErrors = [
    "showHPTError",
    "showHPAError",
    "showNocAmountTrancheError",
    "showNocRequiredError",
    "showIsNameTransferError",
    "showIsInterRTOTransfer",
  ];

  let check = true;

  formFields.forEach(({ key, subStepKey }, idx) => {
    // Check if the field is visible and editable
    if (
      !(
        requiredSubStepFields?.[subStepKey]?.is_visible === 1 &&
        requiredSubStepFields?.[subStepKey]?.is_editable === 1
      )
    ) {
      return;
    }

    // Special handling for nocAmountTranche
    if (key === "nocAmountTranche") {
      if (+state.NOCRequired === 1) {
        check =
          state[key] != null &&
          String(state[key]).trim() !== "" &&
          Number(state[key]) !== 0;
        state[fieldErrors[idx]] = !check;
      }
      return;
    }

    // Skip if the visibility object does not allow it
    if (key === "isNameTransfer" && !visibilityObj.name_transfer) return;
    if (key === "isInterRTOTransfer" && !visibilityObj.inter_rto) return;

    // General validation logic
    if (state[key] != null && state[key] !== "") {
      state[fieldErrors[idx]] = false;
    } else {
      state[fieldErrors[idx]] = true;
      check = false;
    }
  });

  // Update the state with validation results
  setState({ ...state });
  return check;
};

export const insuranceFormValidate = (
  state,
  setState,
  requiredSubStepFields
) => {
  const formFields = [
    { key: "expiry_date", subStepKey: "expiry_date" },
    { key: "insuranceNumber", subStepKey: "policy_number" },
    { key: "insuranceCompany", subStepKey: "company_insurance" },
    { key: "insuranceDv", subStepKey: "idv_insurance" },
  ];

  const fieldErrors = [
    "showExpiryDateError",
    "showInsuranceNumberError",
    "showInsuranceCompanyError",
    "showInsuranceDvError",
  ];

  let check = true;

  formFields.forEach(({ key, subStepKey }, idx) => {
    // Check visibility and editability in requiredSubStepFields
    if (
      !(
        requiredSubStepFields?.[subStepKey]?.is_visible === 1 &&
        requiredSubStepFields?.[subStepKey]?.is_editable === 1
      )
    ) {
      return;
    }

    // Special handling for "expiry_date" and "insuranceCompany"
    if (["expiry_date", "insuranceCompany"].includes(key)) {
      check = state[key] != null && state[key] !== "";
      state[fieldErrors[idx]] = !check;
      return;
    }

    // General validation logic
    if (state[key] != null && state[key] !== "") {
      state[fieldErrors[idx]] = false; // No error
    } else {
      state[fieldErrors[idx]] = true; // Set error
      check = false; // Mark overall validation as failed
    }
  });

  // Update state with error flags
  setState({ ...state });
  return check; // Return final validation result
};

export const ownershipFormValidate = (
  state,
  setState,
  firCheck,
  requiredSubStepFields
) => {
  const formFields = [
    { key: "originalRC", subStepKey: "original_rc" },
    { key: "ownership", subStepKey: "current_owner" },
    { key: "isFirCopy", subStepKey: "fir_copy" },
    { key: "isForm26", subStepKey: "form_26" },
  ];

  const fieldErrors = [
    "showOriginalRCError",
    "showOwnershipError",
    "showIsFirCopyError",
    "showIsForm26Error",
  ];

  let check = true;

  formFields.forEach(({ key, subStepKey }, idx) => {
    // Check if the field is visible and editable
    if (
      !(
        requiredSubStepFields?.[subStepKey]?.is_visible === 1 &&
        requiredSubStepFields?.[subStepKey]?.is_editable === 1
      )
    ) {
      return;
    }

    // Special handling for "isFirCopy" and "isForm26" when firCheck is false
    if (["isFirCopy", "isForm26"].includes(key)) {
      if (!firCheck) {
        check = state[key] != null && state[key] !== "";
        state[fieldErrors[idx]] = !check;
      }
      return;
    }

    // General validation for all fields
    if (state[key] != null && state[key] !== "") {
      state[fieldErrors[idx]] = false; // No error for non-empty fields
    } else {
      state[fieldErrors[idx]] = true; // Set error if field is empty
      check = false; // Mark overall check as false if validation fails
    }
  });

  // Update the state with the validation results
  setState({ ...state });
  return check; // Return the final validation result
};

export const disbursalDetailFormValidate = (
  state,
  setState,
  requiredSubStepFields
) => {
  const formFields = [
    { key: "formalDoDoc", subStepKey: "formal_do" },
    { key: "los_id", subStepKey: "los_id" },
    { key: "netDisbursementAmount", subStepKey: "net_amount" },
    { key: "deductionLoanSurakshaAmount", subStepKey: "loan_suraksha" },
    { key: "deductionStampdutyAmount", subStepKey: "stamp_duty" },
    { key: "deductionAdvemiAmount", subStepKey: "advanced_emi" },
    { key: "deductionOthersAmount", subStepKey: "other_deductions" },
    { key: "clearRCUStatus", subStepKey: "rcu_ok" },
  ];

  const fieldErrors = [
    "showFormalDoDocError",
    "showLosIdError",
    "showNetAmountError",
    "showLoanSurakshaError",
    "showStampDutyError",
    "showAdvancedEMIError",
    "showOtherAmountError",
    "showRCUOkError",
  ];

  let check = true;

  formFields.forEach(({ key, subStepKey }, idx) => {
    // Skip validation if the field is not visible or not editable
    if (
      !(
        requiredSubStepFields?.[subStepKey]?.is_visible === 1 &&
        requiredSubStepFields?.[subStepKey]?.is_editable === 1
      )
    ) {
      return;
    }

    // General validation logic
    if (state[key] != null && state[key] !== "") {
      state[fieldErrors[idx]] = false; // No error
    } else {
      state[fieldErrors[idx]] = true; // Set error
      check = false; // Mark validation failure
    }
  });

  // Update state with validation results
  setState({ ...state });
  return check; // Return overall validation status
};

export const buyerDetailsFormValidate = (
  state,
  setState,
  visibilityObj,
  requiredSubStepFields
) => {
  const formFields = [
    { key: "customerName", subStepKey: "customer_name" },
    { key: "isAddressMatch", subStepKey: "address_match" },
    { key: "isSignatureMatch", subStepKey: "signature_match" },
  ];

  const fieldErrors = [
    "showCustomerNameError",
    "showIsAddressMatchError",
    "showIsSignatureMatchError",
  ];

  let check = true;

  formFields.forEach(({ key, subStepKey }, idx) => {
    // Skip validation if the field is not visible or editable according to requiredSubStepFields
    if (
      !(
        requiredSubStepFields?.[subStepKey]?.is_visible === 1 &&
        requiredSubStepFields?.[subStepKey]?.is_editable === 1
      )
    ) {
      return;
    }

    // Skip validation for "isSignatureMatch" if it is not visible in visibilityObj
    if (key === "isSignatureMatch" && !visibilityObj.is_signature_match) {
      return;
    }

    // Perform validation: Check if the field has a value
    if (state[key] != null && state[key] !== "") {
      state[fieldErrors[idx]] = false; // No error
    } else {
      state[fieldErrors[idx]] = true; // Error found
      check = false; // Mark validation failure
    }
  });

  // Update the state with validation results
  setState({ ...state });
  return check; // Return overall validation status
};

export const validateNetAmount = (state, setState) => {
  let val = 0,
    check = false,
    finalTotal = parseInt(state.netDisbursementAmount);
  if (isNaN(finalTotal) || +finalTotal < 0) {
    setState({ ...state, netDisbursementAmount: 0 });
    return { msg: "Please enter positive number only", error: true };
  }

  const fieldErrors = [
    "showLoanSurakshaError",
    "showStampDutyError",
    "showAdvancedEMIError",
    "showOtherAmountError",
  ];

  [
    "deductionLoanSurakshaAmount",
    "deductionStampdutyAmount",
    "deductionAdvemiAmount",
    "deductionOthersAmount",
  ].forEach((field, idx) => {
    if (!isNaN(+state[field])) {
      state[fieldErrors[idx]] = false;
      val += +state[field];
      if (val > 0) check = true;
    }
  });

  if (check) {
    finalTotal += val;
  }
  setState({ ...state, grossAmount: finalTotal });
  return {};
};

export const validateIndividualAmount = (state, setState, field, errorId) => {
  if (+state[field] < 0) {
    setState({ ...state, [field]: 0 });
    return { msg: "Please enter positive number only", error: true };
  }

  let netAmount = 0,
    val = 0,
    check = false,
    finalTotal = parseInt(state.netDisbursementAmount);

  if (isNaN(finalTotal) || +finalTotal < 0) {
    setState({ ...state, netDisbursementAmount: 0 });
    return { msg: "Please enter postive number as a net amount", error: true };
  }

  if (state.grossAmount) netAmount = state.grossAmount;

  const fieldErrors = [
    "showLoanSurakshaError",
    "showStampDutyError",
    "showAdvancedEMIError",
    "showOtherAmountError",
  ];

  [
    "deductionLoanSurakshaAmount",
    "deductionStampdutyAmount",
    "deductionAdvemiAmount",
    "deductionOthersAmount",
  ].forEach((field, idx) => {
    if (!isNaN(+state[field])) {
      state[fieldErrors[idx]] = false;
      val += +state[field];
      if (val > 0) check = true;
    }
  });

  if (netAmount <= 0) {
    setState({ ...state, [field]: 0, [errorId]: true });
    return { msg: "Net amount is zero. Please enter valid value", error: true };
  }

  if (check) {
    finalTotal += val;
  }
  setState({ ...state, grossAmount: finalTotal });
  return {};
};

export const getCompletedStepDetails = (
  step_details,
  sub_stage,
  stepSelected
) => {
  if (!step_details) return null;
  const parsedDetails = JSON.parse(step_details);
  if ([3, 4, 12, 14].includes(+sub_stage)) {
    parsedDetails.l1[stepSelected].is_completed = 1;
  } else {
    parsedDetails.l0[stepSelected].is_completed = 1;
  }
  return JSON.stringify(parsedDetails);
};
